// src/admin/MarksListPage.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import BASE_URL from "../config";
import { footerConfigs } from "../components/footerConfigs";
export default function MarksListPage() {
  //const [mode, setMode] = useState("single"); // "single" | "bulk" | "notify"
  const [mode, setMode] = useState("subject");
  const [exams, setExams] = useState([]);
  const [selectedExam, setSelectedExam] = useState(null);
  // Single & Bulk
  const [students, setStudents] = useState([]);           // { value, label, mobile }
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [subjects, setSubjects] = useState([]);           // { SubjectID, SubjectName, TotalMarks }
  const [marks, setMarks] = useState({});
  const [grades, setGrades] = useState({});
  const [file, setFile] = useState(null);
  const [uploadResult, setUploadResult] = useState(null);
  // Notifications
  const [notifyData, setNotifyData] = useState([]);       // { StudentID, StudentName, mobile, marks, checked, customMsg }
  const [includeGrade, setIncludeGrade] = useState(false);
  const [errors, setErrors] = useState({}); // track per-subject errors
  const [usertype, setUserType] = useState(null);
const [regid, setRegId] = useState(null);
const [selectedSubject, setSelectedSubject] = useState(null);

const [subjectStudents, setSubjectStudents] = useState([]);

const [subjectErrors, setSubjectErrors] = useState({});

const [Loading, setLoading] =
    useState(false);

  // Utility: grade from percentage
  const getGrade = (p) => {
    if (p >= 90) return "A";
    if (p >= 80) return "B";
    if (p >= 70) return "C";
    if (p >= 60) return "D";
    return "F";
  };
useEffect(()=>{
const RegId=sessionStorage.getItem(
'adminRegId'
);
const TypeId=sessionStorage.getItem(
'userTypeId'
);
 setRegId(RegId);
  setUserType(Number(TypeId)); // convert to number
  console.log(usertype,regid);
}, []);
  // 1) Load exams on mount
  /* useEffect(() => {
    axios.get(`${BASE_URL}/api/exams`)
      .then(res => setExams(res.data))
      .catch(console.error);
  }, []); */
  //30-7-26
  useEffect(() => {

  //if (usertype === "") return;
   if (!regid || !usertype) return;

  axios.get(`${BASE_URL}/api/exams`, {
      params: {
          userType: usertype,
          staffRegID: regid
      }
  })
  .then(res => setExams(res.data))
  .catch(console.error);

}, [usertype, regid]);

//31-7-26//
/* useEffect(() => {

    if (regid && usertype) {

        axios.get(`${BASE_URL}/api/exams`, {
            params: {
                userType: usertype,
                staffRegID: regid
            }
        })
        .then(res => setExams(res.data))
        .catch(console.error);

    }

}, [usertype,regid]); */

  // 2) When exam changes, load subjects & students
  useEffect(() => {
    if (!selectedExam) return;
    const { ExamID, CourseID, ClassID, SectionID, AcademicYearID } = selectedExam;
     // Load subjects for this exam/class/year
  axios.get(`${BASE_URL}/api/exams/${ExamID}/subjects`, {
    params: { courseId: CourseID, 
              classId: ClassID, 
              sectionId:SectionID, 
              yearId: AcademicYearID, 
              role: Number(usertype) === 3 ? "staff" : "admin",
              staffId: regid            
            }
  })
  .then(res => setSubjects(res.data))
  .catch(console.error);
  // Load students for this class/year
  axios.get(`${BASE_URL}/api/exams/by-course-class`, {
    params: { courseId: CourseID, classId: ClassID,sectionId: SectionID, yearId: AcademicYearID }
  })
  .then(res => {
     console.log("API response", res.data);
    const list = Array.isArray(res.data.students) ? res.data.students : [];
    setStudents(list.map(s => ({
      value: s.StudentID,
      label: s.StudentName,
      mobile: s.MobileNumber
    })));
  })
  .catch(console.error);
  // reset downstream
  setSelectedStudent(null);
  setMarks({});
  setFile(null);
  setUploadResult(null);
  setNotifyData([]);
}, [selectedExam, usertype, regid]);
//for subjectwise mode//
useEffect(()=>{
if(
!selectedExam ||
!selectedSubject
)return;
axios.get(
`${BASE_URL}/api/exam-marks/subject-wise`,
{
params:{
examId:selectedExam.ExamID,
courseId:selectedExam.CourseID,
classId:selectedExam.ClassID,
sectionId:selectedExam.SectionID,
yearId:selectedExam.AcademicYearID,
subjectId:selectedSubject.SubjectID
}
}
)
.then(res=>setSubjectStudents(res.data))
.catch(console.error);
},
[selectedExam,selectedSubject]);
  // 3) Load marks for single mode 22-8-25
useEffect(() => {
  if (selectedStudent && selectedExam) {
    axios
      .get(`${BASE_URL}/api/exam-marks?examId=${selectedExam.ExamID}&studentId=${selectedStudent.value}`)
      .then((res) => {
        const formattedMarks = {};
        const formattedGrades = {};
        res.data.forEach((row) => {
          if (row.MarksObtained === -1) {
            formattedMarks[row.SubjectID] = "Ab";   // show "Ab"
          }  else {
            formattedMarks[row.SubjectID] = row.MarksObtained.toString();
          }
          formattedGrades[row.SubjectID]=row.Grade || "";
        });
        setMarks(formattedMarks);
        setGrades(formattedGrades);
      })
      .catch((err) => console.error(err));
  }
}, [selectedStudent, selectedExam]);
  // 4) Build notifyData when entering notify mode or changing exam
  useEffect(() => {
    if (mode !== "notify" || !selectedExam || students.length === 0) {
      setNotifyData([]);
      return;
    }
    axios.get(`${BASE_URL}/api/exam-marks`, {
      params: { examId: selectedExam.ExamID, all: true }
    })
    .then(res => {
      console.log("Exam Marks API", res.data);
      // group marks by StudentID
      const byStudent = {};
      res.data.forEach(r => {
  if (!byStudent[r.StudentID]) {
    byStudent[r.StudentID] = {};
  }
  byStudent[r.StudentID][r.SubjectID] = {
    marks: r.MarksObtained,
    grade: r.Grade
  };
});
      // merge with full student list
      const arr = students.map(s => ({
        StudentID:   s.value,
        StudentName: s.label,
        mobile:      s.mobile,
        marks:       byStudent[s.value] || {},
        checked:     true,
        customMsg:   ""      // start empty; placeholder shows default
      }));
      console.log(arr);
      setNotifyData(arr);
    })
    .catch(console.error);
  }, [mode, selectedExam, students]);
  //consolidate marks list
  useEffect(()=>{
if(
mode!=="consolidate"
||
!selectedExam
)
return;
const{
ExamID,
CourseID,
ClassID,
SectionID,
AcademicYearID
}=selectedExam;
window.open(
`${BASE_URL}/api/reports/consolidate-marks?examId=${ExamID}&courseId=${CourseID}&classId=${ClassID}&sectionId=${SectionID}&yearId=${AcademicYearID}`,
"_blank"
);
},[mode,selectedExam]);

/* //----Report Card------
useEffect(() => {

    if (
        mode !== "reportcard" ||
        !selectedExam
    ) {
        return;
    }


    const {
        ExamID,
        CourseID,
        ClassID,
        SectionID,
        AcademicYearID
    } = selectedExam;


    // --------------------------------------------------
    // SCHOOL CONFIG
    // --------------------------------------------------

    const schoolKey = "bheema";

    const schoolConfig =
        footerConfigs[schoolKey] || {};


    const trust =
        schoolConfig.trust || "";


    const schoolName =
        schoolConfig.brandName || "";


    const affiliationNo =
        schoolConfig.affiliationNo || "830827";


    // --------------------------------------------------
    // BUILD URL
    // --------------------------------------------------

    const params = new URLSearchParams({

        examId: ExamID,

        courseId: CourseID,

        classId: ClassID,

        sectionId:
            SectionID === null ||
            SectionID === undefined
                ? "null"
                : SectionID,

        yearId: AcademicYearID,

        trust,

        schoolName,

        affiliationNo

    });


    const reportUrl =
        `${BASE_URL}/api/reports/pdf?${params.toString()}`;


    console.log(
        "REPORT CARD URL:",
        reportUrl
    );


    // --------------------------------------------------
    // OPEN PDF
    // --------------------------------------------------

    window.open(
        reportUrl,
        "_blank"
    );


}, [mode, selectedExam]); */


// --------------------------------------------------
// REPORT CARD PDF DOWNLOAD
// --------------------------------------------------

useEffect(() => {

    if (
        mode !== "reportcard" ||
        !selectedExam
    ) {
        return;
    }

    const downloadReportCard = async () => {

        try {

            setLoading(true);

            const {
                ExamID,
                CourseID,
                ClassID,
                SectionID,
                AcademicYearID
            } = selectedExam;

            // --------------------------------------------------
            // SCHOOL CONFIG
            // --------------------------------------------------

            const schoolKey = "bheema";

            const schoolConfig =
                footerConfigs[schoolKey] || {};

            const trust =
                schoolConfig.trust || "";

            const schoolName =
                schoolConfig.brandName || "";

            const affiliationNo =
                schoolConfig.affiliationNo || "830827";


            // --------------------------------------------------
            // PARAMETERS
            // --------------------------------------------------

            const params = {

                examId: ExamID,

                courseId: CourseID,

                classId: ClassID,

                sectionId:
                    SectionID === null ||
                    SectionID === undefined ||
                    SectionID === ""
                        ? null
                        : SectionID,

                yearId: AcademicYearID,

                trust: trust,

                schoolName: schoolName,

                affiliationNo: affiliationNo
            };


            console.log(
                "Downloading Report Card:",
                params
            );


            // --------------------------------------------------
            // GET PDF AS BLOB
            // --------------------------------------------------

            const response = await axios.get(
                `${BASE_URL}/api/reports/pdf`,
                {
                    params: params,
                    responseType: "blob"
                }
            );


            // --------------------------------------------------
            // CREATE DOWNLOAD URL
            // --------------------------------------------------

            const blob = new Blob(
                [response.data],
                {
                    type: "application/pdf"
                }
            );

            const downloadUrl =
                window.URL.createObjectURL(blob);


            // --------------------------------------------------
            // FILE NAME
            // --------------------------------------------------

            const examName =
                selectedExam.ExamName
                    ? selectedExam.ExamName
                        .replace(/[^a-zA-Z0-9-_]/g, "_")
                    : "Exam";

            const className =
                selectedExam.ClassName
                    ? selectedExam.ClassName
                        .replace(/[^a-zA-Z0-9-_]/g, "_")
                    : "Class";

            const sectionName =
                selectedExam.SectionName
                    ? `_${selectedExam.SectionName
                        .replace(/[^a-zA-Z0-9-_]/g, "_")}`
                    : "";


            const fileName =
                `Report_Card_${examName}_${className}${sectionName}.pdf`;


            // --------------------------------------------------
            // FORCE DOWNLOAD
            // --------------------------------------------------

            const link =
                document.createElement("a");

            link.href = downloadUrl;

            link.download = fileName;

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);


            // --------------------------------------------------
            // CLEANUP
            // --------------------------------------------------

            setTimeout(() => {

                window.URL.revokeObjectURL(
                    downloadUrl
                );

            }, 1000);


        } catch (error) {

            console.error(
                "Report Card PDF Download Error:",
                error
            );


            // If backend returns JSON error
            if (
                error.response &&
                error.response.data
            ) {

                try {

                    const text =
                        await error.response.data.text();

                    console.error(
                        "Backend Error:",
                        text
                    );

                } catch (e) {

                    console.error(e);

                }

            }

            alert(
                "Unable to download Report Card PDF."
            );

        } finally {

            setLoading(false);

        }

    };


    downloadReportCard();

}, [mode, selectedExam]);




  // ---- Single handlers ----
const handleMarkChange = (subjectId, value, maxMarks) => {
  let parsedValue;
  if (value.trim().toLowerCase() === "ab") {
    parsedValue = -1; // absent
  } else if (value === "") {
    parsedValue = 0; // keep blank as empty
  } else if (!isNaN(value)) {
    parsedValue = parseInt(value, 10);
  } else {
    parsedValue = value; // invalid input
  }
  // validation: check if entered > max
  if (!isNaN(parsedValue) && parsedValue > maxMarks) {
    setErrors(prev => ({
      ...prev,
      [subjectId]: `Marks should be less than or equal to ${maxMarks}`,
    }));
  } else {
    setErrors(prev => {
      const newErr = { ...prev };
      delete newErr[subjectId];
      return newErr;
    });
  }
  setMarks(prev => ({
    ...prev,
    [subjectId]: value, // preserve what user typed
  }));
};
  const handleSaveSingle = e => {
    e.preventDefault();
    if (!selectedStudent) return alert("Select a student");
    const payloads = subjects.map(s => ({
      ExamID: selectedExam.ExamID,
      StudentID: selectedStudent.value,
      SubjectID: s.SubjectID,
      MarksObtained: marks[s.SubjectID] || 0,
      Grade: grades[s.SubjectID],
      CourseID: selectedExam.CourseID,
      ClassID: selectedExam.ClassID,
      SectionID:selectedExam.SectionID,
      AcademicYearID: selectedExam.AcademicYearID
    }));
    Promise.all(payloads.map(p => axios.post(`${BASE_URL}/api/exam-marks`, p)))
      .then(() => alert("Marks saved"))
      .catch(() => alert("Error saving marks"));
  };
  // ---- Bulk handlers ----
  const handleFileChange = e => {
    setFile(e.target.files[0]);
    setUploadResult(null);
  };
  const handleUpload = () => {
    if (!file) return alert("Select a file");
    const fd = new FormData();
    fd.append("file", file);
    axios.post(`${BASE_URL}/api/exam-marks/upload`, fd, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(res => setUploadResult(res.data))
    .catch(err => {
    console.log(err.response);
    if (err.response) {
        alert(err.response.data.error);
    } else {
        alert(err.message);
    }
});
  };
  // ---- Notify helpers ----
  const toggleRow = i => {
    setNotifyData(d => {
      const c = [...d];
      c[i] = { ...c[i], checked: !c[i].checked };
      return c;
    });
  };
  const allChecked = notifyData.length > 0 && notifyData.every(r => r.checked);
  const toggleAll  = () => {
    setNotifyData(d => d.map(r => ({ ...r, checked: !allChecked })));
  };
  const updateMsg  = (i, m) => {
    setNotifyData(d => {
      const c = [...d];
      c[i] = { ...c[i], customMsg: m };
      return c;
    });
  };
// helper: build DLT vars
function buildDLTMessage(student, examName, subjects, marks, schoolName,includeGrade) {
  const vars = Array(10).fill(""); // {#var#1}..{#var#10}
  // Student name & Exam name
  vars[0] = student.StudentName;
  vars[1] = examName;
  // Prepare subject mark strings
  const subjectStrings = subjects.map(s => {
const record = marks[s.SubjectID];
if (!record) {
    return {
        id: s.SubjectID,
        name: s.SubjectName.toUpperCase(),
        str: `${s.SubjectName.toUpperCase()}:NA`,
        obtained: null,
        min: s.MinMarks,
        total: s.TotalMarks,
        includeInTotal:s.IncludeInTotal,
        isNA: true
    };
}
const displayMark = record.marks == -1 ? "Ab" : record.marks;
const grade = record.grade || "";
return {
    id: s.SubjectID,
    name: s.SubjectName.toUpperCase(),
    str:
        /* includeGrade
            ? `${s.SubjectName.toUpperCase()}:${displayMark}-${grade}/${s.TotalMarks}`
            : `${s.SubjectName.toUpperCase()}:${displayMark}/${s.TotalMarks}`, */
            includeGrade
            ? `${s.SubjectName.toUpperCase()}:${displayMark}-${grade}`
            : `${s.SubjectName.toUpperCase()}:${displayMark}`,
    obtained: record.marks,
    min: s.MinMarks,
    total: s.TotalMarks,
     includeInTotal:s.IncludeInTotal,
    isNA: false
};
  });
  // Template subjects in fixed order
  const templateSubjects = ["KANNADA", "ENGLISH", "HINDI", "MATHS"];
  let overflow = [];
  templateSubjects.forEach((subj, i) => {
    const slotIndex = 2 + i; // {#var#3}..{#var#6}
    const found = subjectStrings.find(s => s.name === subj);
   if (found) {
      vars[slotIndex] = found.str;
    } else {
      // subject not in DB → NA
      vars[slotIndex] = `${subj}:NA`;
    }
  });
  // Collect overflow subjects (not in template)
  overflow = subjectStrings.filter(s => !templateSubjects.includes(s.name));
  // Try to fit overflow subjects into available slots (30 char limit each)
  overflow.forEach(extra => {
    let placed = false;
    for (let i = 2; i <= 5 && !placed; i++) {
      if (vars[i].length + 1 + extra.str.length <= 30) {
        vars[i] += vars[i] ? ";" + extra.str : extra.str;
        placed = true;
      }
    }
  });
//22-7-26 for excluding TotalMarks for IT,COMPUTER IN MESSAGE//
const totalSubjects = subjectStrings.filter(
    s => s.includeInTotal === 1
);
const totalObtained = totalSubjects.reduce((sum,s)=>{
    if(s.obtained==null || s.obtained==-1)
        return sum;
    return sum + Number(s.obtained);
},0);
const totalPossible = totalSubjects.reduce((sum,s)=>{
    if(s.obtained==null)
        return sum;
    return sum + Number(s.total);
},0);
  const perc = totalPossible ? Math.round((totalObtained / totalPossible) * 100) : 0;
 // Result
  let result = "PASS";
    if(
    totalSubjects.some(
        s =>
            s.obtained !== null &&
            (
                s.obtained === -1 ||
                s.obtained < s.min
            )
    )
){
    result="FAIL";
}
// ✅ Compute grade if needed
  const getGrade = (p) => {
     if (p >= 90) return "A";
    if (p >= 80) return "B";
    if (p >= 70) return "C";
    if (p >= 60) return "D";
     return "F";
  };
  let resultText = `Result: ${result}`;
  vars[6] = `${totalObtained}/${totalPossible}`;
  vars[7] = `${perc}%`;
  vars[8] = resultText;
  vars[9] = schoolName;
  return vars;
}
const sendNotifications = async () => {
  if (!notifyData.length) return alert("No students selected.");
  const schoolKey = "bheema";  
  const schoolName = footerConfigs[schoolKey]?.brandName || "Your School";
  const batch = notifyData.filter(r => r.checked);
  if (!batch.length) return alert("No students selected.");
  let successCount = 0;
  let failCount = 0;
  await Promise.all(
    batch.map(async r => {
      try {
        const vars = buildDLTMessage(
          r,
          selectedExam.ExamName,
          subjects,
          r.marks,
          schoolName,
           includeGrade   // 👈 pass toggle state
        );
        console.log("Subjects:", subjects);
console.log("Marks:", r.marks);
console.log("Vars:", vars);
        const message = `Dear Parent/Guardian,
Here are the marks obtained by ${vars[0]} in the Exam ${vars[1]}
${vars[2]}
${vars[3]}
${vars[4]}
${vars[5]}
Total: ${vars[6]}
Percentage: ${vars[7]}
${vars[8]}
From, ${vars[9]}
-SCHAMY`;
const res = await axios.post(`${BASE_URL}/api/send-mark-sms`, {
         /*  params: { mobile: r.mobile,  message: encodeURIComponent(message) } */
         mobile: r.mobile,
         message
        });
        console.log("SMS MESSAGE");
console.log(message);
        if (res.data.success) {
          successCount++;
        } else {
          console.error("Failed (API error):", r.StudentName, res.data.error);
          failCount++;
        }
      } catch (err) {
        console.error("Failed (network):", r.StudentName, err.message);
        failCount++;
      }
    })
  );
  if (successCount > 0 && failCount === 0) {
    alert(`✅ Sent ${successCount} message(s) successfully`);
  } else if (successCount === 0 && failCount > 0) {
    alert(`❌ All ${failCount} message(s) failed`);
  } else {
    alert(`⚠️ Sent ${successCount} message(s), but ${failCount} failed`);
  }
};
const saveSubjectWise = () => {
    // Existing validation
    if (Object.keys(subjectErrors).length > 0) {
        alert("Please correct marks greater than maximum marks.");
        return;
    }
    // Double validation
    const invalid = subjectStudents.find(s => {
        const marks =
            s.MarksObtained === null ||
            s.MarksObtained === undefined
                ? ""
                : String(s.MarksObtained).trim();
        // Blank marks are allowed
        // They mean this subject is not entered / not opted
        if (marks === "") {
            return false;
        }
        // AB is allowed
        if (marks.toLowerCase() === "ab") {
            return false;
        }
        // Must be numeric
        if (isNaN(Number(marks))) {
            return true;
        }
        return Number(marks) > Number(selectedSubject.TotalMarks);
    });
    if (invalid) {
        alert(
            `${invalid.StudentName} entered invalid marks. Maximum marks are ${selectedSubject.TotalMarks}`
        );
        return;
    }
    axios.post(
        `${BASE_URL}/api/exam-marks/subject-wise`,
        {
            ExamID: selectedExam.ExamID,
            CourseID: selectedExam.CourseID,
            ClassID: selectedExam.ClassID,
            SectionID: selectedExam.SectionID,
            AcademicYearID: selectedExam.AcademicYearID,
            SubjectID: selectedSubject.SubjectID,
            students: subjectStudents
        }
    )
    .then((res) => {

        alert(
            res.data.message || "Marks Saved Successfully"
        );

    })
    .catch((error) => {

        console.error(error);

        alert(
            error.response?.data?.error ||
            "Failed to save marks"
        );

    });
};
const handleSubjectMarkChange = (studentId, value, maxMarks) => {
  let parsedValue;
  if (value.trim().toLowerCase() === "ab") {
    parsedValue = -1;
  } else if (value === "") {
    parsedValue = 0;
  } else if (!isNaN(value)) {
    parsedValue = parseInt(value, 10);
  } else {
    parsedValue = value;
  }
  // Validation
  if (
    parsedValue !== -1 &&
    parsedValue !== "" &&
    !isNaN(parsedValue) &&
    parsedValue > maxMarks
  ) {
    setSubjectErrors(prev => ({
      ...prev,
      [studentId]: `Marks should be less than or equal to ${maxMarks}`
    }));
  } else {
    setSubjectErrors(prev => {
      const obj = { ...prev };
      delete obj[studentId];
      return obj;
    });
  }
  // Update student marks
  setSubjectStudents(prev =>
    prev.map(s =>
      s.StudentID === studentId
        ? {
            ...s,
            MarksObtained: value
          }
        : s
    )
  );
};
  return (
    <div className="container mt-4">
      <h3>Marks Management</h3>
      <ul className="nav nav-pills mb-3">
      <li className="nav-item">
<button
className={`nav-link ${mode==="subject"?"active":""}`}
onClick={()=>setMode("subject")}
>
Subject Wise
</button>
</li>
        <li className="nav-item">
          <button
            className={`nav-link ${mode==="single"?"active":""}`}
            onClick={()=>setMode("single")}
          >Single</button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${mode==="bulk"?"active":""}`}
            onClick={()=>setMode("bulk")}
          >Bulk</button>
        </li>
         {/* Show Notifications only for Admin */}
  {Number(usertype) !== 3 && (
        <li className="nav-item">
          <button
            className={`nav-link ${mode==="notify"?"active":""}`}
            onClick={()=>setMode("notify")}
          >Notifications</button>
          
        </li>
        
  )}
  {Number(usertype) !== 3 && (
     <>
<li className="nav-item">
    <button
        className={`nav-link ${mode==="consolidate"?"active":""}`}
        onClick={()=>setMode("consolidate")}
    >
        Consolidate Marks List
    </button>
</li>
<li className="nav-item">
            <button
                className={`nav-link ${
                    mode === "reportcard" ? "active" : ""
                }`}
                onClick={() => setMode("reportcard")}
            >
                Report Card
            </button>
        </li>
          </>
)}
      </ul>
      {/* Exam selector */}
      <div className="mb-3">
  <label className="form-label">Exam</label>
  <select
    className="form-select"
    value={
      selectedExam
        ? `${selectedExam.ExamID}_${selectedExam.CourseID}_${selectedExam.ClassID}_${selectedExam.SectionID}_${selectedExam.AcademicYearID}`
        : ""
    }
    onChange={e => {
      const ex = exams.find(
        x =>
          `${x.ExamID}_${x.CourseID}_${x.ClassID}_${x.SectionID}_${x.AcademicYearID}` ===
          e.target.value
      );
      setSelectedExam(ex || null);
    }}
  >
    <option value="">-- Select Exam --</option>
    {exams.map(ex => (
      <option
        key={`${ex.ExamID}_${ex.CourseID}_${ex.ClassID}_${ex.SectionID}_${ex.AcademicYearID}`}
        value={`${ex.ExamID}_${ex.CourseID}_${ex.ClassID}_${ex.SectionID}_${ex.AcademicYearID}`}
      >
        {ex.DisplayName}
      </option>
    ))}
  </select>
</div>
      {!selectedExam && (
        <div className="alert alert-info">
          Please select an exam to {mode==="single"
            ? "enter marks"
            : mode==="bulk"
              ? "download/upload template"
              : mode==="subject"
              ? "enter marks"
              :mode==="consolidate"
              ? "download consolidate excel "
              : mode === "reportcard"
                ? "generate report card"
              : "send notifications"}.
        </div>
      )}
{/*Subject wise mode*/}
{mode==="subject" && selectedExam && (

<div className="mb-3">

<label>Select Subject</label>

<select
className="form-select"
value={selectedSubject?.SubjectID||""}
onChange={(e)=>{

const s=subjects.find(
x=>Number(x.SubjectID)===Number(e.target.value)
);

setSelectedSubject(s);

}}
>

<option value="">Select</option>

{subjects.map(s=>

<option
key={s.SubjectID}
value={s.SubjectID}
>
{s.SubjectName}
</option>
)}
</select>

</div>
)}
{mode==="subject"
&&
selectedSubject
&&
(
<table className="table table-bordered">
<thead>
<tr>
<th>Roll No</th>
<th>Student</th>
<th>Parent Name</th>
<th>Marks</th>
<th>Grade</th>
</tr>
</thead>
<tbody>
{subjectStudents.map((s,index)=>(
<tr key={s.StudentID}>
<td>{s.RollNumber}</td>
<td>{s.StudentName}</td>
<td>{s.ParentName}</td>
<td>
<input
    type="text"
    className={`form-control ${
        subjectErrors[s.StudentID] ? "is-invalid" : ""
    }`}
    value={s.MarksObtained === -1 ? "Ab" : (s.MarksObtained ?? "")}
    onChange={(e) =>
        handleSubjectMarkChange(
            s.StudentID,
            e.target.value,
            selectedSubject.TotalMarks
        )
    }
/>
{subjectErrors[s.StudentID] && (
    <div className="invalid-feedback">
        {subjectErrors[s.StudentID]}
    </div>
)}
</td>
<td>
<input
className="form-control"
value={s.Grade||""}
onChange={(e)=>{
const value=e.target.value.toUpperCase();
setSubjectStudents(prev=>
prev.map(x=>
x.StudentID===s.StudentID
?
{
...x,
Grade:value
}
:
x
)
);
}}
 />
</td>
</tr>
))}
</tbody>
<button
className="btn btn-success"
onClick={saveSubjectWise}
>
Save All
</button>
</table>
)}
      {/* Single Mode */}
      {mode==="single" && selectedExam && (
        <form onSubmit={handleSaveSingle}>
          <div className="mb-3">
            <label className="form-label">Student</label>
            <Select
              options={students}
              value={selectedStudent}
              onChange={setSelectedStudent}
              placeholder="Type to search…"
            />
          </div>
          {subjects.map(s=>(
            <div key={s.SubjectID} className="mb-2 d-flex align-items-center">
              <div className="flex-grow-1">
                <div className="flex-grow-1">
                {s.SubjectName} <small>(out of {s.TotalMarks})</small>
              </div>
              <input
                type="text"
                 className={`form-control ${errors[s.SubjectID] ? "is-invalid" : ""}`}
                style={{width:120}}
                value={marks[s.SubjectID]||""}
                onChange={e => handleMarkChange(s.SubjectID, e.target.value, s.TotalMarks)}
                required
              />
            </div>
<div className="col-md-3">
  <input
    type="text"
    className="form-control"
    placeholder="Grade"
    maxLength={3}
    value={grades[s.SubjectID] || ""}
    onChange={(e) => {
      const value = e.target.value.toUpperCase();
      setGrades(prev => ({
        ...prev,
        [s.SubjectID]: value
      }));
    }}
  />
</div>
                {errors[s.SubjectID] && (
      <div className="text-danger small">{errors[s.SubjectID]}</div>
    )}
    </div>
          ))}
          <button
            type="submit"
            className="btn btn-primary mt-3"
            disabled={!selectedStudent}
          >Save Marks</button>
        </form>
      )}
      {/* Bulk Mode */}
      {mode==="bulk" && selectedExam && (
        <>
         <a
  className="btn btn-outline-secondary mb-3"
  href={
    Number(usertype) === 3
      ? `${BASE_URL}/api/exam-marks/upload/template?examId=${selectedExam.ExamID}&courseId=${selectedExam.CourseID}&classId=${selectedExam.ClassID}&sectionId=${selectedExam.SectionID ?? "null"}&yearId=${selectedExam.AcademicYearID}&role=staff&staffId=${regid}`
      : `${BASE_URL}/api/exam-marks/upload/template?examId=${selectedExam.ExamID}&courseId=${selectedExam.CourseID}&classId=${selectedExam.ClassID}&sectionId=${selectedExam.SectionID ?? "null"}&yearId=${selectedExam.AcademicYearID}`
  }
>
  Download Template
</a>
          <div className="mb-3">
            <input
              type="file"
              accept=".xlsx"
              className="form-control"
              onChange={handleFileChange}
            />
          </div>
          <button
            className="btn btn-success mb-3"
            onClick={handleUpload}
            disabled={!file}
          >Upload & Import</button>
          {uploadResult && (
  <div className="mt-3">
    {uploadResult.success ? (
      <div className="alert alert-success">All good! Inserted {uploadResult.processed}.</div>
    ) : (
      <>
        <div className="alert alert-warning">
          Inserted: {uploadResult.processed} • Errors: {uploadResult.errors?.length || 0}
        </div>
        {!!uploadResult.errors?.length && (
          <ul className="small">
            {uploadResult.errors.map((e, i) => (
              <li key={i}>
                StudentID {e.studentId} — {e.subject}: {e.error}
              </li>
            ))}
          </ul>
        )}
      </>
    )}
  </div>
)}
        </>
      )}
      {/* Notifications Mode */}
      {mode==="notify" && selectedExam && (
        <div className="mt-4">
          <h4>Notify Students</h4>
          <div className="form-check form-switch mb-3">
            <input
              type="checkbox"
              id="toggleGrade"
              className="form-check-input"
              checked={includeGrade}
              onChange={()=>setIncludeGrade(g=>!g)}
            />
            <label htmlFor="toggleGrade" className="form-check-label">
              Include Grade
            </label>
          </div>
          <button
            className="btn btn-sm btn-secondary mb-2"
            onClick={toggleAll}
          >
            {allChecked ? "Unselect All" : "Select All"}
          </button>
          <button
            className="btn btn-sm btn-primary mb-2 ms-2"
            onClick={sendNotifications}
          >
            Send Selected
          </button>
          <div
  className="table-responsive"
  style={{
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
  }}
>
  <table
    className="table table-bordered"
    style={{
      width: "100%",
      borderCollapse: "collapse",
      fontSize: "14px",
    }}
  >
    <thead
      style={{
        background: "#f8f9fa",
        position: "sticky",
        top: 0,
        zIndex: 2,
      }}
    >
      <tr>
        <th style={{ width: "5%", minWidth: "40px" }}></th>
        <th style={{ minWidth: "120px" }}>Student</th>
        <th style={{ minWidth: "100px" }}>Score</th>
        <th style={{ minWidth: "60px" }}>%</th>
       {/*  {includeGrade && <th style={{ minWidth: "80px" }}>Grade</th>} */}
        <th style={{ minWidth: "220px" }}>Message</th>
      </tr>
    </thead>
    <tbody>
      {notifyData.map((row, i) => {

// Only subjects included in total calculation
const totalSubjects = subjects.filter(
    s => Number(s.IncludeInTotal) === 1
);

// Total Obtained
const obtained = totalSubjects.reduce((sum, s) => {
    const rec = row.marks[s.SubjectID];

    if (!rec || rec.marks == -1)
        return sum;

    return sum + Number(rec.marks);
}, 0);

// Total Possible
const possible = totalSubjects.reduce((sum, s) => {
    return sum + Number(s.TotalMarks);
}, 0);

// Percentage
const perc = possible > 0
    ? Math.round((obtained / possible) * 100)
    : 0;

/* const obtained = subjects.reduce((sum, s) => {
    const rec = row.marks[s.SubjectID];
    if (!rec || rec.marks == -1)
        return sum;
    return sum + Number(rec.marks);
}, 0);
        const possible = subjects.reduce((sum, s) => sum + s.TotalMarks, 0);
        const perc = possible
          ? Math.round((obtained / possible) * 100)
          : 0; */
        //const grade = includeGrade ? getGrade(perc) : null;
        
        const breakdown = subjects
          .map((s) => {
            const rec = row.marks[s.SubjectID];
            //const grade = row.Grade[s.SubjectID];
if (!rec)
    return `${s.SubjectName}: NA`;
const displayMark = rec.marks == -1 ? "Ab" : rec.marks;
const grade = rec.grade || "";
return includeGrade
   /*  ? `${s.SubjectName}:${displayMark}-${grade || ""}/${s.TotalMarks}`
    : `${s.SubjectName}:${displayMark}/${s.TotalMarks}`; */
     ? `${s.SubjectName}:${displayMark}-${grade || ""}`
    : `${s.SubjectName}:${displayMark}`;
          })
          .join(", ");
        const placeholderMsg =
          `Hi ${row.StudentName}, your marks for ${selectedExam.ExamName} are:\n` +
          `${breakdown}.\nTotal: ${obtained}/${possible} (${perc}%).`;
          /*  + */
         /*  (grade ? ` Grade: ${grade}.` : ""); */
        return (
          <tr
            key={row.StudentID}
            style={{
              borderBottom: "1px solid #dee2e6",
              verticalAlign: "top",
            }}
          >
            <td style={{ textAlign: "center" }}>
              <input
                type="checkbox"
                checked={row.checked}
                onChange={() => toggleRow(i)}
              />
            </td>
            <td style={{ whiteSpace: "nowrap" }}>{row.StudentName}</td>
            <td>{obtained}/{possible}</td>
            <td>{perc}%</td>
            <td>
              <textarea
                className="form-control"
                style={{
                  width: "100%",
                  minHeight: "120px",
                  fontSize: "13px",
                  resize: "vertical",
                }}
                rows={3}
                value={row.customMsg}
                placeholder={placeholderMsg}
                onChange={(e) => updateMsg(i, e.target.value)}
              />
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
</div>
        </div>
      )}
{/*Consolidate marks list*/}
      {mode === "consolidate" && selectedExam && (
    <div className="alert alert-success">
        Preparing Consolidated Marks Report...
    </div>
)}

{/*Report card*/}
{mode === "reportcard" && selectedExam && (
    <div className="alert alert-success">

        Generating Report Cards for:

        <strong className="ms-2">
            {selectedExam.DisplayName}
        </strong>

        <div className="mt-2">
            Report Card PDF will contain
            <strong> 4 students per A4 page</strong>.
        </div>

    </div>
)}
    </div>
  );
}
